import React from 'react';
import { ImageHelper } from '../../classes/image-helper.class';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import SeoReview from '../seo-review';

const SeoAnimalShelter = ({ city, email, logo, rescueName, address, slug, specializations, state, testimonials }) => {
    const myCity = city?.toLowerCase() || '';
    const fixCity = myCity == 'none' ? '' : myCity;
    const myKeywords = specializations?.join(', ');
    const myReview =
        testimonials?.length > 0
            ? {
                  comment: testimonials[0].testimonial,
                  user: {
                      nameAndInitial: testimonials[0].reviewerName,
                  },
              }
            : null || null;

    return (
        <div itemScope itemType="https://schema.org/AnimalShelter" className="d-none">
            <div itemProp="name">{rescueName}</div>
            <span itemProp="image">{ImageHelper.getUrlFromOptions(logo, `full-fit-in/${IMG_RESIZES.x768}`)}</span>
            <div itemType="https://schema.org/PostalAddress" itemScope itemProp="address">
                {address && <div itemProp="streetAddress">{address}</div>}
                <div>
                    {fixCity && <span itemProp="addressLocality">{fixCity}</span>}
                    {state && <span itemProp="addressRegion">{state}</span>}
                    <span itemProp="addressCountry">US</span>
                </div>
            </div>
            <meta itemProp="currenciesAccepted" content="USD" />
            {slug && <meta itemProp="url" content={`/${slug}`} />}
            {email && <span itemProp="email">{email}</span>}
            {myKeywords && <span itemProp="keywords">{myKeywords}</span>}
            {myKeywords && <span itemProp="email">{myKeywords}</span>}
            {myReview && <SeoReview {...{ ...myReview, itemProp: 'review' }} shelter />}
        </div>
    );
};

export default SeoAnimalShelter;
